module.exports = __webpack_public_path__ + "build/desktop/a/img/icon_point_neutral.1a4fdbd6f9392404c517eaf8d145d697.svg";